module.exports = __webpack_public_path__ + "assets/roboto-v15-latin-regular-4ae284.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.woff2
// module id = 826
// module chunks = 2